import apolloCache from "../../lib/graphql/apolloCache";
import { IUser } from "../../types/user";
import GetMe from "../repository/withMe/graphql/GetMe";

export const getMeFromCache = (): IUser | null | undefined => {
  try {
    const queryResponse = apolloCache.readQuery<{
      me: IUser | undefined;
    }>({
      query: GetMe,
    });

    return queryResponse && queryResponse.me;
  } catch (e) {
    return undefined;
  }
};
